import React from 'react';
import { toFormattedLocalDate } from 'utils/dateTime/converter';
import { getTimeRemaining } from 'utils/dateTime/DueDateCountDown';

// getFormattedDueDate logic pulled from AssessmentsTable.jsx
export const getFormattedDueDate = (translate, dueDate) => {
  const daysRemaining = getTimeRemaining(dueDate).days;
  let dueDateDisplay = toFormattedLocalDate(dueDate);
  let styleObject;

  switch (true) {
    case daysRemaining <= -1:
      dueDateDisplay = `${Math.abs(daysRemaining)} ${translate('common.dateTime.daysOverdue')}`;
      styleObject = { fontWeight: 600, color: '#f44336' };
      break;

    case daysRemaining <= 6 && daysRemaining > 0:
      dueDateDisplay =
        daysRemaining === 1
          ? `${translate('common.dateTime.dueIn')} ${daysRemaining} ${translate('common.dateTime.day')}`
          : `${translate('common.dateTime.dueIn')} ${daysRemaining} ${translate('common.dateTime.days')}`;
      styleObject = { fontWeight: 600, color: '#f47236' };
      break;

    case daysRemaining === 0:
      dueDateDisplay = translate('common.dateTime.dueToday');
      styleObject = { fontWeight: 600, color: '#f47236' };
      break;

    default:
      break;
  }
  return (
    <span data-dueDate={dueDate} style={{ ...styleObject }}>
      {dueDateDisplay}
    </span>
  );
};

export const getFormattedSubmitDate = (translate, submittedDate, includeTime) => {
  let result = '';
  if (includeTime) {
    result = toFormattedLocalDate(submittedDate, `MM/DD/YYYY [${translate('common.dateTime.at')}] h:mm A`);
  } else {
    result = toFormattedLocalDate(submittedDate, 'MM/DD/YYYY');
  }
  return result;
};

export const formatOwners = (owners = []) => {
  return owners
    .map(owner => {
      const { firstName, lastName } = owner;
      return `${firstName} ${lastName}`;
    })
    .join(', ');
};
